module.exports = __webpack_public_path__ + "static/img/f11.c690341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/daas_case/f11.png
// module id = vpz5
// module chunks = 0